import React from "react";
import PropTypes from "prop-types";
import { PlantTankIcon } from "../../Icons";
import { TankTooltip } from "./TankTooltip";
import className from "./style.module.scss";
import { Image } from "@learningblocks/shared-components";

export function Tank(props) {
  const [show, setShow] = React.useState(false);

  const toggleShow = (value) => () => setShow(value);

  return (
    <div
      className={className.tank}
      onMouseEnter={toggleShow(true)}
      onMouseLeave={toggleShow(false)}
    >
      {show && <TankTooltip label={props.label} />}
      <Image
        src={PlantTankIcon}
        alt={`Tank with ${props.numberOfPlants} water plant${props.numberOfPlants === 1 ? "" : "s"}`}
      />
    </div>
  );
}

Tank.propTypes = {
  /**
   * Label to display on Tank
   */
  label: PropTypes.string,
};

Tank.defaultProps = {};
